/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This function performs an Object.assign but does not explode on trying to set a read-only property
 * @param  {Object} target  Target to apply sources properties to
 * @param  {Array<Object>} sources Any number of sources to be applied to target
 * @return {Object}        The updated target object;
 */
export function assignSafe(target: object, ...sources: any[]) {
  const proto = Object.getPrototypeOf(target);
  const safe = sources.map((source) => {
    const entries = Object.entries(source ?? {});
    const reduced = entries.reduce((accumulator: [string, unknown][], currentValue) => {
      const descriptor = Object.getOwnPropertyDescriptor(proto, currentValue[0]);
      if (!descriptor || descriptor.set) {
        accumulator.push(currentValue);
      }
      return accumulator;
    }, []);
    return fromEntries(reduced);
  });
  return Object.assign(target, ...safe);
}

export function fromEntries(propArray: [string, unknown][]): Record<string, unknown> {
  const response: any = {};
  propArray.forEach(([key, value]) => {
    response[key] = value;
  });
  return response;
}
